import OwlCarousel from 'react-owl-carousel';
export default function TestimonialFour(){
    return(
        <section class="testimonial-area testimonial-area2 nav-style-1 pt-120 pb-60 pt-md-60 pt-xs-60 home-4">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="core-feature-title text-center">
							<p class="lh-1 mb-10">Happy Users</p>
							<h2 class="sect-title">Client Reviews</h2>
						</div>
					</div>
				</div>
			</div>
			<div class="custom-container-1">
					
                <OwlCarousel items={1}  
			className="owl-theme testimonial-slide3"  
			loop 
			dots={false}
            autoplay={true}
            center={true}			  
			margin={0} >
                <div class="item">
                    <div class="author-img">
                        <img src="assets/img/home-4/team-women-1-150x150.jpg" alt="Image" />
                    </div>
                    <div class="testimonial-text-wrapper2">
                        <div class="author-box">
                            <div class="author-content">
                                <h6>Ariana Grande</h6>
                                <p>-CEO</p>
                            </div>
                            <h5 class="fs-20">“ Professional &amp; modern, a theme designed
                                to help your business stand out from the rest.
                                For marketing firms. ”</h5>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="author-img">
                        <img src="assets/img/home-4/team-women-2-150x150.jpg" alt="Image" />
                    </div>
                    <div class="testimonial-text-wrapper2">
                        <div class="author-box">
                            <div class="author-content">
                                <h6>Jennifer Lopez</h6>
                                <p>-Manager</p>
                            </div>
                            <h5 class="fs-20">“ Professional &amp; modern, a theme designed
                                to help your business stand out from the rest.
                                For marketing firms. ”</h5>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="author-img">
                        <img src="assets/img/home-4/team-men-4-150x150.jpg" alt="Image" />
                    </div>
                    <div class="testimonial-text-wrapper2">
                        <div class="author-box">
                            <div class="author-content">
                                <h6>Mr. Phoenix</h6>
                                <p>-Head Of Idea</p>
                            </div>
                            <h5 class="fs-20">“ Professional &amp; modern, a theme designed
                                to help your business stand out from the rest.
                                For marketing firms. ”</h5>
                        </div>
                    </div>
                </div>
                <div class="item">
						<div class="author-img">
							<img src="assets/img/home-4/team-women-1-150x150.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2">
							<div class="author-box">
								<div class="author-content">
									<h6>Ariana Grande</h6>
									<p>-CEO</p>
								</div>
								<h5 class="fs-20">“ Professional &amp; modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”</h5>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="author-img">
							<img src="assets/img/home-4/team-women-2-150x150.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2">
							<div class="author-box">
								<div class="author-content">
									<h6>Jennifer Lopez</h6>
									<p>-Manager</p>
								</div>
								<h5 class="fs-20">“ Professional &amp; modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”</h5>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="author-img">
							<img src="assets/img/home-4/team-men-4-150x150.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2">
							<div class="author-box">
								<div class="author-content">
									<h6>Mr. Phoenix</h6>
									<p>-Head Of Idea</p>
								</div>
								<h5 class="fs-20">“ Professional &amp; modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”</h5>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="author-img">
							<img src="assets/img/home-4/team-women-1-150x150.jpg" alt="Image" />
						</div>
						<div class="testimonial-text-wrapper2">
							<div class="author-box">
								<div class="author-content">
									<h6>Ariana Grande</h6>
									<p>-CEO</p>
								</div>
								<h5 class="fs-20">“ Professional &amp; modern, a theme designed
									to help your business stand out from the rest.
									For marketing firms. ”</h5>
							</div>
						</div>
					</div>
            </OwlCarousel>	
			</div>
		</section>
    )
}